<template>
  <div id="app">
    <v-app class="grey lighten-4" id="MultiTicket">
      <div>
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-title>ItalyServices</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn dark icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
  
              <v-list>
                <v-list-item  @click="reload()"><v-list-item-title>{{ $t('reload_app') }}</v-list-item-title></v-list-item>
                <v-list-item><v-subheader>{{ $t('language') }}</v-subheader></v-list-item>
                <v-list-item @click="setLocale('it')"><v-list-item-title>Italiano</v-list-item-title></v-list-item>
                <v-list-item @click="setLocale('en')"><v-list-item-title>English</v-list-item-title></v-list-item>
                <v-list-item @click="setLocale('fr')"><v-list-item-title>Français</v-list-item-title></v-list-item>
              </v-list>
            </v-menu>
      </v-toolbar>
      </div>
      
      <v-content fluid fill-height>
        <v-container>
                <v-alert type="warning" v-if="isOffline">{{$t('offline_alert')}}</v-alert>
        <router-view></router-view>

        </v-container>
      </v-content>
      
      <v-bottom-navigation fixed dark background-color="blue darken-4" centered icons-and-text
        slider-color="white">
        <v-btn router to="/" ripple>Home
          <v-icon>home</v-icon>
        </v-btn>
        <v-btn router to="/services" ripple>{{ $t('services') }}
          <v-icon>explore</v-icon>
        </v-btn>
        <v-btn router to="/about" ripple>{{ $t('about') }}
          <v-icon>info</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </v-app>
    </div>
</template>

<script>
//import i18n from '@/plugins/i18n'
  export default {
    data() {
      return {
        drawer: false,
      }
    },
    methods:{
       setLocale(val){
        this.$root.$i18n.locale = val;
        this.$store.dispatch('getExtras',val)
        this.$store.dispatch('loadServices',val)
      },
        reload()
        {
          location.reload(true);
        }
    }
    
  }
</script>

<style>

</style>